//---- Loader class
import React from "react";
import {postApi} from '../utils/functions';


export default class Functions {

	constructor(props) {
	}

	loadContentEmoji(service, content, style, custom = false) {
		
		if( content.indexOf('https://') === 0 )
			return new Promise(async(resolve, reject) => {

				let _content = [], width = 0, height = 0;
				let params = new URLSearchParams();
				params.append('image', content);
				params.append('style', style);
				const x = await postApi(`${service}/v3/template/emote`, params);
				//console.log(x.data);
				width = x.data.width;
				height = x.data.height;
				for( let i in x.data.data ) {
					_content.push(new Image());
					_content[i].src = `data:image/png;base64,${x.data.data[i]}`
				}


				resolve({
					data: _content, width: (custom===true)?x.data.width:32, height: (custom===true)?x.data.height:32
				});


				//resolve(_content);
			});

		else

			return new Promise(async(resolve, reject) => {
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				ctx.font = '30px serif';
				let metrics = ctx.measureText(content);
				ctx.canvas.width = metrics.width;
				ctx.canvas.height = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent+4;
				ctx.font = '30px serif';
				ctx.textAlign = "center";
				ctx.textBaseline = "middle";
				ctx.fillText(content, ctx.canvas.width / 2, ctx.canvas.height / 2+2);
				let image = new Image();
				image.src = ctx.canvas.toDataURL();
				const pixels = {data: image, width: metrics.width, height: metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent+4};
				resolve(pixels);
			});
	}
	
	loadContentEmotes(emoteurl) {
    return new Promise(async(resolve, reject) => {

      let _content = [], width = 0, height = 0;

      //if( await this.checkContent(emoteurl) === false ) {
        let params = new URLSearchParams();
        params.append('image', emoteurl);
        const x = await postApi('/v3/template/emote', params);
				//console.log(x.data);
        width = x.data.width;
        height = x.data.height;
        for( let i in x.data.data ) {
          _content.push(new Image());
          _content[i].src = `data:image/png;base64,${x.data.data[i]}`
        }
      //}
			resolve(_content);
			return;
			/*
      let content = {...this.state.content};
      if( !content ) content = {};
      if( _content ) content[emoteurl] = {
        data: _content,
        width,
        height
      };
      //---- Store Emotes
      let emote = await this.emotes.current.process(emoteurl, this.timeframe);
      let emotes = this.state.emotes;
      if( !emotes ) emotes = [];
      emotes.push(emote);
      if( _content.length > 0 )
        this.setState({content, emotes}, ()=>{
          resolve(true);
        });
      else
        this.setState({emotes}, ()=>{
          resolve(true);
        });
			*/
    });
  }

	loadContentImage(content) {
		return new Promise(async(resolve, reject) => {
			const image = new Image();
			image.src = content;
			image.onload = function () {
				resolve({data: image, width: image.width, height: image.height});
			}

			/*
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');
			const image = new Image();
			image.crossOrigin = "anonymous";
			image.src = content;
			image.onload = function () {
				canvas.width = image.width; 
				canvas.height = image.height; 
				ctx.drawImage(image, 0, 0); 
				const pixels = ctx.getImageData(0, 0, image.width, image.height).data;
				resolve(pixels);
			}
			*/
		});
	}

	loadContentAnimated(content) {
		return new Promise(async(resolve, reject) => {
			//gifFrames({ url: 'image.gif', frames: 0 }).then(function (frameData) {
				//console.log(frameData);
				//const apng = await parseAPNG(content);
				//console.log(apng);
				resolve(true);
			//});
		});
	}


}

export class Particles {
	constructor(x, y, color) {
		this.x = x;
		this.y = y;
		this.color = color;
		this.originX = 0;
		this.originY = 0;
		this.size = 2;
		this.dx = 0;
		this.dy = 0;
		this.vx = 0;
		this.vy = 0;
		this.force = 0;
		this.angle = 0;
		this.distance = 0;
		this.friction = Math.random() * 0.6 + 0.15;
		this.ease = Math.random() * 0.1 + 0.005;
		this.time = Date.now()+2000;
	}
	draw(ctx, x, y) {
		ctx.fillStyle = this.color;
		ctx.fillRect(this.x + x, this.y + y, this.size, this.size);

	}
	explode(x, y) {
		//if( this.originX === 0 ) this.originX = this.x-50;
		//if( this.originY === 0 ) this.originY = this.y-50;
		this.dx = x - this.x;
		this.dy = y - this.y;
		this.distance = this.dx * this.dx + this.dy * this.dy;
		this.force = -20000 / this.distance;
		
		

		//if( this.distance > 20000 && Date.now() > this.time && Date.now() < this.time + 2000 ) {
			this.angle = Math.atan2(this.dy, this.dx);
			this.vx -= Math.cos(this.angle);
			this.vy -= Math.sin(this.angle);
		//}

		/*if( this.originX === 0 ) {
			//this.angle = Math.atan2(this.dy, this.dx);
			//this.vx += this.force * Math.cos(this.angle);
			//this.vy += this.force * Math.sin(this.angle);
			this.originX = this.x-40;
			this.originY = this.y-40;
		}*/
		

		this.x += (this.vx *= this.friction) +  this.ease;
		this.y += (this.vy *= this.friction) + this.ease;
	}
}